import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { connectInfiniteHits } from 'instantsearch.js/es/connectors';
import { BaseWidget } from './base-widget';
import type { Hit } from './search.types';
import { Hits } from 'instantsearch.js';

interface InfiniteHitsState {
  hits: Hit[];
  isLastPage: boolean;
  showMore: () => void;
}

@Component({
  selector: 'app-infinite-hits',
  template: `
    <ng-container *ngIf="state && resultTemplate">
      <ng-container *ngTemplateOutlet="resultTemplate; context: { hits: state.hits }" />
      <div #sentinel class="infinite-hits__sentinel"></div>
    </ng-container>
  `
})
export class InfiniteHitsComponent
  extends BaseWidget<InfiniteHitsState>
  implements AfterViewInit
{
  @Input() transformHits?: (hits: Hit[]) => Hit[];
  @ContentChild(TemplateRef) resultTemplate?: TemplateRef<{
    hits: Hits;
    viewType: 'tile' | 'list';
  }>;

  @ViewChild('sentinel') sentinel!: ElementRef;
  private observer!: IntersectionObserver;

  ngAfterViewInit(): void {
    this.initObserver();
  }

  override ngOnDestroy() {
    this.observer?.disconnect();
    super.ngOnDestroy();
  }

  createWidget() {
    return connectInfiniteHits(renderState => {
      // Cast via unknown to resolve the intersection type conflict
      const hits = renderState.hits as unknown as Hit[];

      this.updateState({
        hits: this.transformHits ? this.transformHits(hits) : hits,
        isLastPage: renderState.isLastPage,
        showMore: renderState.showMore
      });
    })({});
  }

  // Call this after state is set the first time
  private initObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !this.state.isLastPage) {
          this.state.showMore();
        }
      },
      { threshold: 1.0 }
    );

    if (this.sentinel?.nativeElement) {
      this.observer.observe(this.sentinel.nativeElement);
    }
  }
}
